export const ParticipantTypeValues = {
  MAIN_BOOKER: 'MainBooker',
  COMPANION: 'Companion',
  NONE: 'None',
} as const

export type ParticipantType = typeof ParticipantTypeValues[keyof typeof ParticipantTypeValues]
